export default function auth({ next, store }) {
    if (!store.isLoggedIn) {
        return next({ path: '/login' });
    }

    return next();
}